import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { MysqlService } from './../../../services/mysql.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import {Location} from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel, columnSelectionComplete } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { environment } from './../../../../environments/environment';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
// import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-upload-docx-theme-template',
  templateUrl: './upload-docx-theme-template.component.html',
  styleUrls: ['./upload-docx-theme-template.component.css']
})
export class UploadDocxThemeTemplateComponent implements OnInit {

  @Input() brand_id: number;
  @Input() doc_id: number;
  @Input() title = '<< Default Title >>';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;


loading: boolean;
// set an event emitter to send back to parent component
@Output() action = new EventEmitter();



sessionBrandId: any;
sessionUsername: any;
sessionUserId: any;
currentUserVAR: any;

div: any;
public nav: any;
public body: any;
public container: any;
// Uploader Service Vars
// public title = 'File Upload Manager - Brands';
// public imgUploaded: string;
public tableData: any;
public baseUploadURL = environment.baseUploadURLOriginalWordTemplates; // no trailing slash // added brand_id to HTML 
sent_brand_id: any;
sent_doc_id: any;


// grid settings
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
initialPage: { pageSize: number; };
  activeTab: any;
  activeTabId: any;
  value: string;

  // TABS
  // required for tab action events
@Output() events  = new EventEmitter();
// TABS sets the selected
@ViewChild('staticTabs') staticTabs: TabsetComponent;
@ViewChild('1') 1: TabDirective;
@ViewChild('2') 2: TabDirective;
  all_router_details: string;
  current_base_route: string;
  wrapSettings: { wrapMode: string; };

  constructor(
    private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
    private modelService: BsModalService,   
    private _location: Location, public gfunc: GlobalFunctionsService
  ) { 

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
  }

  ngOnInit() {

    // load file list
    // this.refreshList2();

    this.loadList(this.doc_id);
    

    this.wrapSettings = { wrapMode: 'Content' };
         // syncfusion GRID OPTIONS
         this.toolbarOptions = ['Search'];
         this.initialPage = { pageSize: 5 };
         this.filterOptions = {
           type: 'Menu'
        };
       // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};
       // end grid options
    
      }


  ngOnChanges(): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    this.sent_brand_id = this.brand_id;
    this.sent_doc_id = this.doc_id;
    // this.loadList(this.doc_id);

  }



// Uploader Functions
public uploadBrandImage(brand_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadBrandImage(formData, brand_id).subscribe(res=> this.dataLoaded(res));


}




public uploadDotTemplate(doc_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadDotTemplateFiles(formData, doc_id).subscribe(res=> this.dataLoaded(res));


}



public uploadDocxThemeTemplate(doc_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadDocxThemeTemplateFiles(formData, doc_id).subscribe(res=> this.dataLoaded(res));
// this.toastr.success('File Uploaded Sucessfully');

// console.log('dataLoaded: ', JSON.stringify(this.dataLoaded));
this.selectTab(1);
// this.loadList(null);
// this.refreshGrid();
// this.changeTab(2);

}




public uploadDocxTemplate(doc_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadDocxTemplateFiles(formData, doc_id).subscribe(res=> this.dataLoaded(res));


}



// Uploader Functions
public uploadImage(): void {
  // this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadImage(formData).subscribe(res=> this.dataLoaded(res));
}


dataLoaded(data: any): void {
// this.elem.nativeElement.querySelector('#spinner').style.visibility = 'hidden';
 // this.imgUploaded = data._body;
this.refreshList();
}

refreshList(): void {
// this.fileUploader.getDotTemplateFiles(this.doc_id).subscribe(res=> this.displayTableData(res));
this.fileUploader.getDocxThemeTemplateFiles(this.doc_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
this.tableData = data
}

// end uploader functions


loadList(doc_id): void {
  this.fileUploader.getDocxThemeTemplateFiles(doc_id).subscribe(res=> this.displayTableData(res));
  
  }



public clickOk() {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(true); /// << here you can send object  instead of true
}


public clickFile(filename) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(filename); /// << here you can send object  instead of true
  this.bsModalRef.hide();
}


// Edit a Theme component.
editThemeFile(file_id, filename){
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/theme-docx-edit/' + file_id + '/' + filename]);
};




// Grid Functions
toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.loadList(this.doc_id);
  this.grid.refresh();
};


gridItemView(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + id + '']);
}

gridItemEdit(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + id + '']);
}


// end grid functions



// TABS component
/// TABS
selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
  // this.refreshList();
  // this.refreshGrid();
};


   // to router navigate back
public goBack() {
  this._location.back();
}

// when a tab button is pressed an event is sent.
public changeTab($event) {
  this.activeTab = $event.heading;
  this.activeTabId = $event.id;
  if (this.activeTabId === 2) {
    // this.loadList(this.doc_id);
    console.log('File List Loaded');
}
}

tabSelect(data: TabDirective): void {
  this.value = data.heading;
  // this.loadList(this.doc_id);
  console.log(this.value);
  if (this.value === 'Browse Server') {
    console.log('File List Loaded');
}
}




}